// frontend/src/stores/auth.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { UserInfo } from '@/types/api'

export const useAuthStore = defineStore('auth', () => {
  // State
  const token = ref<string | null>(localStorage.getItem('token'))
  const user = ref<UserInfo | null>(null)

  // Getters
  const isAuthenticated = computed(() => !!token.value)
  const userName = computed(() => user.value?.udm_person?.name || '')
  const userDepartment = computed(() => user.value?.udm_person?.department || '')
  // 获取用户钉钉ID
  const userId = computed(() => user.value?.person_id || '')
  // 获取带工号的完整名称，格式：姓名:工号
  const userFullName = computed(() => {
    const name = user.value?.udm_person?.name || ''
    const empCode = user.value?.udm_person?.emp_code || ''
    if (name && empCode) {
      return `${name}:${empCode}`
    }
    return name
  })
  // 获取带工号的完整部门，格式：部门:工号
  const userFullDepartment = computed(() => {
    const department = user.value?.udm_person?.department || ''
    const empCode = user.value?.udm_person?.emp_code || ''
    if (department && empCode) {
      return `${department}:${empCode}`
    }
    return department
  })

  // 角色相关判断
  const isSuperAdmin = computed(() => user.value?.is_super_admin ?? false)
  const isSystemAdmin = computed(() => user.value?.is_system_admin ?? false)
  const isApprovalAdmin = computed(() => user.value?.is_approval_admin ?? false)
  // 研发角色判断
  const isRdPerson = computed(() => user.value?.is_rd ?? false)
  const rdType = computed(() => user.value?.rd_type ?? null)

  // Actions
  function setAuth(authToken: string, userInfo: UserInfo) {
    token.value = authToken
    user.value = userInfo
    localStorage.setItem('token', authToken)
    localStorage.setItem('user', JSON.stringify(userInfo))
    console.log('[Auth] 登录成功, is_super_admin:', userInfo.is_super_admin)
  }

  function logout() {
    token.value = null
    user.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }

  function initFromStorage() {
    const storedToken = localStorage.getItem('token')
    const storedUser = localStorage.getItem('user')
    if (storedToken && storedUser) {
      token.value = storedToken
      try {
        user.value = JSON.parse(storedUser)
      } catch {
        logout()
      }
    }
  }

  return {
    token,
    user,
    isAuthenticated,
    userName,
    userDepartment,
    userId,
    userFullName,
    userFullDepartment,
    isSuperAdmin,
    isSystemAdmin,
    isApprovalAdmin,
    isRdPerson,
    rdType,
    setAuth,
    logout,
    initFromStorage,
  }
})